<template>
  <div id="DocumentLimitTransactionNormalTerms" class="sun not-full">
    <div class="title">{{ list[0].title }}</div>
    <div class="content">{{ list[0].content }}</div>
    <v-collapse-wrapper
      ref="NormalTerms"
      @afterClose="isCollapse = false"
      @afterOpen="isCollapse = true"
    >
      <div v-collapse-content>
        <div :key="index" v-for="(item, index) in list" v-show="index > 0">
          <div class="title">{{ item.title }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
      <div v-collapse-toggle>
        <button class="collapse">
          {{ isCollapse ? '내용 접기' : '내용 더보기' }}
        </button>
      </div>
    </v-collapse-wrapper>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionNormalTerms',
  props: ['isCompleted'],
  data: function () {
    return {
      isCollapse: false,
      list: [
        {
          title: '제1조 상환방식',
          content:
            '1. 대출금의 상환 및 이자의 지급은 은행송금\n' +
            ' (채권자 입금계좌)등 당사자가 약정한 방법에 의한다.\n' +
            '\n' +
            '2. 대출금의 상환 및 이자의 지급은 \n비용, 이자, 원금순으로 충당한다.' +
            '\n',
        },
        {
          title: '제2조 지연손해금',
          content:
            '이자, 분할상환금, 분할상환 원리금을 대출 만기일까지 전액 상환하지 못하거나 제3조에 의한 기한의 이익을 상실한 때에는 그 다음날부터 남은 대출 잔액에 대해 연체이자율에 의한 지연손해금을 지급하기로 한다.',
        },
        {
          title: '제3조 기한의 이익상실',
          content:
            '1. 이자를 지급해야하여야 할 때부터 2개월간 지체한 때 \n' +
            '2. 분할상환금 또는 분할상환원리금의 지급을 2회 이상 \n 연속하여 지체하고 그 금액이 대출금의 10분의 1을 초과하는 경우\n' +
            '3. 온라인연계대출계약약관 제11조 기한전의 채무변제의무 발생시 \n' +
            '4. 만기경과시\n',
        },
      ],
    }
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    open(refName) {
      this.$refs[refName].open()
    },
  },
}
</script>

<style lang="scss" scoped>
#DocumentLimitTransactionNormalTerms {
  padding-bottom: 30px;
  .title {
    font-weight: 600;
    font-size: 16px;
    margin-top: 30px;
  }
  .content {
    font-size: 16px;
    line-height: 1.5;
    margin-top: 13px;
  }
  button.collapse {
    width: 100%;
    height: 50px;
    font-weight: 600;
    font-size: 18px;
    color: #727d8c;
    border-radius: 24px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    margin-top: 20px;
  }
}
</style>
